<template>
  <div class="panels-3-wrap">
    <h3>{{ getrans('Discover more') }}</h3>
    <div class="panels-3-inner">
      <template  v-for="panel in panels_group['1'].columns" :key="panel.panelid">
       <div class="panel-card">
          <img :src="panel.image" alt="" />
          <div class="panel-text">
            <h3>{{ getrans(panel.heading) }}</h3>
            <p>{{ getrans(panel.brief_description) }}</p>
            <a :href="panel.button_link" class="panel-link">
              <span>{{ getrans(panel.button_text) }}</span>
              <i class="fas fa-chevron-right"></i>
            </a>
          </div>
        </div>
      </template>
      </div>
  </div>
  <!-- {
  "1": {
    "row": "1",
    "columns": [
      {
        "panel_no_columns": "[{\"row\":\"3\"},{\"row\":\"3\"},{\"row\":\"2\"},{\"row\":\"2\"}]",
        "panel_no_rows": "4",
        "rownum": "1",
        "colnum": "1",
        "button_link": "/",
        "button_text": "Learn More",
        "image_align": "top",
        "brief_description": "Looking for Airport parking? We offer a fantastic range of airport parking options to suit all needs",
        "heading": "Airport Parking",
        "image": "https://res.cloudinary.com/rezcomm2018/image/upload/f_auto,q_auto/v1670431425/brands/AIR/panels/1670431424_cavValet.png/go96e2yb3wvxjcgkehqj.png",
        "panelid": 87
      },
      {
        "panel_no_columns": "[{\"row\":\"3\"},{\"row\":\"3\"},{\"row\":\"2\"},{\"row\":\"2\"}]",
        "panel_no_rows": "4",
        "rownum": "1",
        "colnum": "2",
        "button_link": "/",
        "button_text": "Learn More",
        "image_align": "top",
        "brief_description": "Travelling through the airport is easy, fast and friendly but fast track makes things even easier...",
        "heading": "Fast Track Tickets",
        "image": "https://res.cloudinary.com/rezcomm2018/image/upload/f_auto,q_auto/v1670431209/brands/AIR/panels/1670431208_ft_img.png/zzf7r8brb6jwb4vawn1v.png",
        "panelid": 83
      },
      {
        "panel_no_columns": "[{\"row\":\"3\"},{\"row\":\"3\"},{\"row\":\"2\"},{\"row\":\"2\"}]",
        "panel_no_rows": "4",
        "rownum": "1",
        "colnum": "3",
        "button_link": "/",
        "button_text": "Learn More",
        "image_align": "top",
        "brief_description": "Lounge on our comfortable chairs in a quiet environment and feel refreshed before you fly. ",
        "heading": "Airport Lounge",
        "image": "https://res.cloudinary.com/rezcomm2018/image/upload/f_auto,q_auto/v1670431345/brands/AIR/panels/1670431344_airlng.png/v01xdz5y8f3y3wcv2faq.png",
        "panelid": 85
      }
    ]
  }
} -->
</template>

<script>
export default {
  name: "Panels_3",
  props: {
    panels_group: undefined,
    lang: undefined,
    translations: undefined,
    setbrandid: undefined,
    getrans: Function,
  },
};
</script>

<style scoped lang="scss">
.panels-3-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 1rem;
  margin: 4rem auto 2rem;
  h3 {
    margin: 0 0 2rem 0;
    font-weight: bold;
    color: var(--panel_title_font_color);
  }
}

.panels-3-inner {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
}

.stack-container {
  position: relative;
  width: auto;
  height: auto;
  flex: 1;
  img {
    width: 100%;
    height: auto;
    display: block;
  }
}

.element-top,
.element-bottom {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* Optionally, use z-index to control which is on top */
.element-top {
  z-index: 2;
}
.element-bottom {
  z-index: 1;
}

.panel-card {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, .160);
  background: #fff;
  flex: 1;
  min-width: 0;
  text-align: left;
  //cursor: pointer;
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    display: block;
    border-radius: 4px 4px 0 0;
    transition: filter 0.3s;
  }
  &:hover img {
    filter: brightness(0.7);
  }
  .panel-text {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background: rgba(255,255,255,0.95);
    box-shadow: 0 -2px 8px rgba(0,0,0,0.04);
    padding: 1rem 1rem 0.5rem 1rem;
    border-radius: 0 0 4px 4px;
    transition: max-height 0.4s cubic-bezier(.4,0,.2,1), padding 0.3s;
    max-height: 3.2rem; // Only heading visible
    overflow: hidden;
    h3 {
      margin: 0;
      font-size: 1rem;
      font-weight: bold;
      color: var(--panel_title_font_color);
    }
    p {
      margin: 0.5rem 0 0 0;
      opacity: 0;
      transition: opacity 0.3s;
    }
    .panel-link {
      display: flex;
      align-items: center;
      margin-top: 0.7rem;
      font-weight: 500;
      color: #1a2a3a;
      opacity: 0;
      transition: opacity 0.3s;
      text-decoration: none;
      span {
        text-decoration: underline;
      }
      i {
        margin-left: 0.5rem;
        text-decoration: none;
      }
    }
  }
  &:hover .panel-text {
    max-height: 220px; // Reveal all text
    padding: 1rem;
    p, .panel-link {
      opacity: 1;
    }
  }
}


@import "@/assets/sass/override_brand.scss";
</style>